import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  generateKey,
  getHeader,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const service = {
  state: {
    adminService: {},
    service: {},
    serviceList: [],
    listDiscount: "",
    fanpageId: "",
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      state = {
        ...state,
        ...payload,
      };
      return {
        ...state,
      };
    },
  },
  effects: (dispatch) => ({
    async getServiceReportByPackage(payload = {}, rootState) {
      let url =
        DomainAPI + Channel + `/api/secure/services/getServiceReportByPackage`;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    async getInfoQRcode(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        `/api/public/services/getInfoQRcode?serviceCode=${payload.serviceCode}`;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      return fetch(url, {
        method: "GET",
        headers: myHeaders,
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    getServiceByCode(payload = {}, rootState) {
      const _this = this;
      let url =
        DomainAPI +
        Channel +
        "/api/secure/services/findByServiceCodeForAdmin?no=" +
        payload.no;
      let header = getHeader(true, rootState.user.token);
      return fetch(url, {
        method: "GET",
        headers: header,
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result && result.code === 1) {
            _this.setState({ adminService: result.data });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    getServicesForRole(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/services/getServicesForRole";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              service: result.data.length ? result.data[0] : result.data,
            });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    getListServicesForAdmin(payload = {}, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/services/getListServicesForAdmin";
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              serviceList: result.data.list,
              total: result.data.total,
              count: result.data.count,
            });
          } else _this.setState({ serviceList: [], total: 0 });
          return result;
        })
        .catch((error) => {
          _this.setState({ serviceList: [], total: 0 });
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateServiceForOwner(payload = {}, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/services/updateServiceForOwner";

      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          service: payload.data,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then(async function (result) {
          checkResponse(result, dispatch);
          _this.getServicesForRole();
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateWorkingHours(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/services/updateWorkingHours";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify({
          workingHours: payload.data,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then(async function (result) {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateServiceForAdmin(payload, rootState) {
      let data = {
        service: payload.data,
        feature: payload.feature,
        functions: payload.functions,
        serviceCode: rootState.service.adminService
          ? rootState.service.adminService.no
          : null || null,
      };
      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceFeatures/updateServiceForAdmin";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
    async deleteServices(payload, rootState) {
      const _this = this;
      let data = payload.listServiceDelete;
      let url =
        DomainAPI + Channel + "/api/secure/services/deleteServiceForAdmin";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.getServicesForRole();
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
    async addNewService(payload, rootState) {
      const _this = this;
      let activeHour =
        '{"monday":{"from":"07:30","to":"18:00","off":0},"tuesday":{"from":"08:30","to":"18:00","off":0},"wednesday":{"from":"08:30","to":"18:00","off":0},"thursday":{"from":"08:30","to":"18:00","off":0},"friday":{"from":"08:30","to":"18:00","off":0},"saturday":{"from":"08:30","to":"18:00","off":0},"sunday":{"from":"08:30","to":"18:00","off":1}}';
      let data = {
        formData: {
          activeHour: JSON.parse(activeHour),
        },
        name: payload.data.name,
        address: payload.data.address,
        userId: 0,
        lat: payload.data.lat,
        lng: payload.data.lng,
        isActive: Number(payload.data.isActive),
        phone: payload.data.phone,
        mobile: payload.data.mobile,
        minPrice: Number(payload.data.minPrice),
        maxPrice: Number(payload.data.maxPrice),
        currencyCode: payload.data.currencyCode,
        description: payload.data.description,
        website: payload.data.website,
        city: payload.data.city,
        district: payload.data.district,
        imageUrl: payload.data.imageUrl,
        support: payload.data.support,
        pointSystem: Number(payload.data.pointSystem),
        logo: payload.data.logo,
      };
      let url = DomainAPI + Channel + "/api/secure/services/createService";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.getServiceByCode({ no: result.data });
          }
          return result;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.message };
        });
    },
    async searchService(payload, rootState) {
      if (!payload) {
        this.getListServicesForAdmin();
      } else {
        let myHeaders = new Headers();
        let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
          expiresIn: SecretApiKeyExpires,
        });
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(APIKey, key);
        myHeaders.append(Authorization, rootState.user.token);
        return fetch(
          DomainAPI + Channel + "/api/secure/services/searchService",
          {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify({
              keySearch: payload,
            }),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            checkResponse(result, dispatch);
            if (result.code === 1) this.setState({ serviceList: result.data });
            else this.setState({ serviceList: [] });
            return result.code === 1 ? true : false;
          })
          .catch((error) => {
            return false;
          });
      }
    },
    async getListDiscount(payload, rootState) {
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/services/getListDiscount",
        {
          method: "POST",
          headers: myHeaders,
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) this.setState({ listDiscount: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateDiscount(payload, rootState) {
      let myHeaders = new Headers();
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(
        DomainAPI + Channel + "/api/secure/services/updateDiscount",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify({
            discount: payload,
          }),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) this.getListDiscount();
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateFanpageId(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/serviceSocials/updateFanpageId";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          fanpageId: payload,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getFanpageId(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/serviceSocials/getFanpageId";
      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async activeServiceForAdmin(payload, rootState) {
      let url =
        DomainAPI + Channel + "/api/secure/services/activeSericeForAdmin";

      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    findByUserCode(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/services/findByUserCode";

      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            this.setState({
              serviceList: res.data,
            });
          }
          return res;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    updateQRcode(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/services/updateQRcode";

      return fetch(url, {
        method: "post",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default service;
